import { render } from "./AccessibilityPage.vue?vue&type=template&id=80d25b10&scoped=true"
import script from "./AccessibilityPage.vue?vue&type=script&lang=js"
export * from "./AccessibilityPage.vue?vue&type=script&lang=js"

import "./AccessibilityPage.vue?vue&type=style&index=0&id=80d25b10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80d25b10"]])

export default __exports__